/**
 * LLM Bot Configuration -- Data Model
 * Generic bot config factory, no app-specific constants.
 */

export function createBotConfig(overrides: any = {}) {
  return {
    botId: overrides.botId || `bot-${Date.now()}`,
    displayName: overrides.displayName || 'New Bot',
    description: overrides.description || '',
    llm: {
      mode: 'remote',
      provider: null as string | null,
      model: null as string | null,
      apiKey: null as string | null,
      workerPublicKey: null as string | null,
      ...overrides.llm,
    },
    role: {
      systemPrompt: null as string | null,
      ...overrides.role,
    },
  }
}
